export default "__VITE_ASSET__BkCFcaHS__"